import { styled } from '@mui/material/styles';

export const Root = styled('div', { label: 'DocumentPageList' })(({ theme }) => ({
  padding: 0,
  display: 'flex',
  flexWrap: 'wrap',

  '& .page-is-dragging': {
    zIndex: 10004,
    boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.1)',

    '& > div': {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
}));
